module.exports = __webpack_public_path__ + "img/escudo-XVII-Leg-blanco.0f4dd535.svg";